import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const SUPPORTED_LANGUAGES = ["fr", "en"] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * react-i18next setup. French is the default/fallback (the platform's primary
 * language). The detector persists the chosen language to localStorage. The
 * API serves translated questionnaire/content via the Accept-Language header —
 * see the API client, which forwards i18n.language.
 *
 * Strings here are seeded for the foundation shell; feature slices add their
 * own keys. Long-term these can be generated from the Django .po catalogs.
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: "fr",
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    // Resources are bundled inline (synchronous), so no Suspense boundary is
    // needed for translation loading.
    react: { useSuspense: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "activateur.lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
